/* Baby In · approved native November bundle landing.
   Native Shopify header/footer/cart. Public JSON verifies product links and prices.
   Routing lives in the hash (#/cat=play&product=ID) so it works from file:// and HTTP. */
(function () {
  'use strict';

  var nativeDocument=window.document;
  var bundleRoot=nativeDocument.getElementById('bi-november-bundles');
  if(!bundleRoot||bundleRoot.dataset.initialized)return;
  bundleRoot.dataset.initialized='true';
  var liveConfig=window.BABY_BUNDLE_LIVE||{};
  var document={
    createElement:nativeDocument.createElement.bind(nativeDocument),
    createTextNode:nativeDocument.createTextNode.bind(nativeDocument),
    getElementById:function(id){return bundleRoot.querySelector('[id="'+(id.indexOf('bib-')===0?id:'bib-'+id)+'"]');},
    querySelector:bundleRoot.querySelector.bind(bundleRoot),
    querySelectorAll:bundleRoot.querySelectorAll.bind(bundleRoot),
    addEventListener:bundleRoot.addEventListener.bind(bundleRoot),
    documentElement:bundleRoot,body:bundleRoot
  };
  Object.defineProperty(document,'activeElement',{get:function(){return nativeDocument.activeElement;}});
  function liveProductUrl(p){var base=liveConfig.rootUrl||'/';if(base.slice(-1)!=='/')base+='/';return base+'products/'+encodeURIComponent(p.handle)+'?view='+(p.customStory?'babyin-bundle-story':'babyin-bundle');}


  /* ---------- Data ---------- */
  var DATA = window.BABY_BUNDLE_DATA || { meta: {}, categories: [], products: [] };
  var META = DATA.meta || {};
  var CAT_IDS = ['outings', 'home', 'feeding', 'play', 'potty'];
  var BUDGETS = ['all', 'lt1000', '1000-2499', '2500-4999', '5000plus'];
  var SORTS = ['suggested', 'asc', 'desc'];
  var VIEWS = ['auto', '1440', '390', '320'];
  var COMPONENTS = DATA.components || {};

  function num(v) {
    if (typeof v === 'number') return isFinite(v) ? v : null;
    if (v == null || v === '') return null;
    var n = parseFloat(String(v).replace(/[^\d.]/g, ''));
    return isFinite(n) ? n : null;
  }
  function arr(v) { return Array.isArray(v) ? v : []; }
  function uniq(list) {
    var out = [];
    list.forEach(function (x) { if (out.indexOf(x) === -1) out.push(x); });
    return out;
  }

  var products = [];
  (function normalize() {
    var seen = {};
    arr(DATA.products).forEach(function (p, i) {
      if (!p || p.launchEnabled!==true || p.id == null || CAT_IDS.indexOf(p.category) === -1) return;
      var id = String(p.id);
      if (seen[id]) return;
      seen[id] = true;
      products.push({
        id: id, handle:p.handle,published:false,available:false,launchReady:p.launchReady===true,
        category: p.category,
        title: p.title || {},
        modelLine: p.modelLine || null,
        intro: p.intro || null,
        benefits: arr(p.benefits).filter(Boolean),
        detailNote: p.detailNote || null,
        components: arr(p.components).filter(Boolean),
        componentKeys: arr(p.componentKeys),
        price: p.price,
        minPrice: p.minPrice,
        referencePrice: p.referencePrice,
        savingsPreview: p.savingsPreview,
        priceVaries: p.priceVaries === true,
        options: arr(p.options).filter(Boolean).map(function (o, j) {
          return {
            id: o.id != null ? String(o.id) : String(j), variantId:String(o.variantId||''),
            label: o.label || {},
            price: o.price,
            referencePrice: o.referencePrice,
            savingsPreview: o.savingsPreview,
            colourHex: typeof o.colourHex === 'string' && /^#[0-9a-f]{3,8}$/i.test(o.colourHex) ? o.colourHex : null,
            componentKeys: arr(o.componentKeys)
          };
        }),
        customStory: p.customStory === true,
        featuredRank: num(p.featuredRank),
        selectionNote: p.selectionNote || {},
        giftLine: p.giftLine || {},
        image: p.image,
        defaultOption: p.defaultOption,
        _i: i
      });
    });
  })();
  var byId = {};
  products.forEach(function (p) { byId[p.id] = p; });
  var categories = CAT_IDS.map(function (id) {
    var src = arr(DATA.categories).filter(function (c) { return c && c.id === id; })[0] || {};
    var imgMap = DATA.categoryImages || {};
    return {
      id: id,
      label: src.label || { ar: id, en: id },
      image: src.image || imgMap[id] || null,
      sourceKeys: arr(src.sourceKeys),
      count: products.filter(function (p) { return p.category === id; }).length
    };
  });
  var catById = {};
  categories.forEach(function (c) { catById[c.id] = c; });
  var featured = products.filter(function (p) { return p.featuredRank != null; })
    .sort(function (a, b) { return a.featuredRank - b.featuredRank; });

  /* ---------- i18n ---------- */
  var T = {"ar":{"cur":function (v) { return v + ' ج.م'; },"from":"يبدأ من","save":function (v) { return 'وفّري ' + v; },"saveVaries":"التوفير حسب اختيارك","optsN":function (n) { return n === 2 ? 'اختيارين' : n + ' اختيارات'; },"searchPh":"دوّري باسم منتج أو باندل","searchLabel":"دوّري في الباندلز","introTitle":"عروض نوفمبر","badgeAlt":"Pink Friday","ctaStory":"خصصي القصة","ctaSee":"شوفي الباندل","prev":"اللي قبله","next":"اللي بعده","picksSub":"باندلز من اختيارنا ليكي","picksTitle":"شهر نوفمبر شهر التوفير","needsTitle":"بتدوري على إيه؟","viewAll":"عرض الكل","allTitle":"كل الباندلز","results":function (n, tot) { return n === tot ? n + ' باندل' : n + ' من ' + tot + ' باندل'; },"bAll":"كل الأسعار","story":"فيها قصة باسم طفلك","budget":"الميزانية","sort":"الترتيب","filters":"الفلاتر","chipQ":function (q) { return 'بحث: ' + q; },"removeChip":function (l) { return 'إزالة: ' + l; },"clearAll":"مسح الكل","emptyT":"مفيش باندلز بالاختيارات دي","emptyP":"جرّبي ميزانية تانية أو كلمة بحث مختلفة.","reset":"رجّعي كل الفلاتر","fillerT":"عايزة تشوفي أكتر؟","fillerAll":function (n) { return 'كل الباندلز (' + n + ')'; },"fillerClear":"امسحي الفلاتر","faq":[["الباندل فيه إيه بالظبط؟","كل كارت مكتوب تحته الموديل، ولما تفتحي الباندل هتلاقي كل قطعة هتوصلك بصورتها وعددها. السعر للباندل كله."],["أختار اللون إزاي؟","من صفحة الباندل قبل الإضافة للشنطة. في بعض الباندلز الاختيار بيحدد لون قطعة واحدة بس، وده مكتوب جنب الاختيارات."],["القصة باسم طفلك بتتعمل إزاي؟","في باندلز القصة بتكتبي اسم طفلك وسنه ونوعه وتضيفي صورته، والقصة بتتجهز على البيانات دي بعد الطلب."]],"faqTitle":"أسئلة قبل ما تختاري","close":"إغلاق","showN":function (n) { return 'عرض ' + n + ' باندل'; },"blt1000":"أقل من 1,000 ج.م","b1000-2499":"1,000 – 2,499 ج.م","b2500-4999":"2,500 – 4,999 ج.م","b5000plus":"5,000 ج.م وأكتر","ssuggested":"مقترح","sasc":"السعر: من الأقل","sdesc":"السعر: من الأعلى"},"en":{"cur":function (v) { return 'EGP ' + v; },"from":"From","save":function (v) { return 'Save ' + v; },"saveVaries":"Saving depends on your choice","optsN":function (n) { return n + ' options'; },"searchPh":"Search a product or bundle","searchLabel":"Search bundles","introTitle":"November Offers","badgeAlt":"Pink Friday","ctaStory":"Personalise story","ctaSee":"See bundle","prev":"Previous","next":"Next","picksSub":"Bundles picked for you","picksTitle":"November is for saving","needsTitle":"What are you shopping for?","viewAll":"View all","allTitle":"All bundles","results":function (n, tot) { return n === tot ? n + ' bundles' : n + ' of ' + tot + ' bundles'; },"bAll":"Any price","story":"Personalised story","budget":"Budget","sort":"Sort","filters":"Filters","chipQ":function (q) { return 'Search: ' + q; },"removeChip":function (l) { return 'Remove: ' + l; },"clearAll":"Clear all","emptyT":"No bundles match these choices","emptyP":"Try another budget or a different search word.","reset":"Reset all filters","fillerT":"Want to see more?","fillerAll":function (n) { return 'All bundles (' + n + ')'; },"fillerClear":"Clear filters","faq":[["What exactly is in a bundle?","Each card shows the models, and every bundle page lists each piece you will receive with its photo and quantity. The price covers the whole bundle."],["How do I choose a colour?","On the bundle page, before adding it to your bag. In some bundles the choice sets the colour of one piece only, and that is noted next to the options."],["How does the personalised story work?","For story bundles you add your child’s name, age, gender and photo, and the story is prepared from those details after ordering."]],"faqTitle":"Before you choose","close":"Close","showN":function (n) { return 'Show ' + n + (n === 1 ? ' bundle' : ' bundles'); },"blt1000":"Under EGP 1,000","b1000-2499":"EGP 1,000 – 2,499","b2500-4999":"EGP 2,500 – 4,999","b5000plus":"EGP 5,000 and up","ssuggested":"Suggested","sasc":"Price: low to high","sdesc":"Price: high to low"}};

  /* Page-local state. The native theme owns the cart and locale. */
  var DEFAULTS={lang:liveConfig.locale==='en'?'en':'ar',cat:'all',q:'',budget:'all',story:false,sort:'suggested',view:'auto',product:null};
  var state=Object.assign({},DEFAULTS);
  var ui={size:'lg',cols:3,revealed:true};
  function t(key) {
    var d = T[state.lang] || T.ar;
    return d[key] != null ? d[key] : T.ar[key];
  }
  function L(obj) {
    if (obj == null) return '';
    if (typeof obj === 'string') return obj;
    return String(obj[state.lang] || obj.ar || obj.en || '');
  }
  function money(v) {
    if (v == null) return '—';
    return t('cur')(Math.round(v).toLocaleString('en-US'));
  }

  /* ---------- DOM helpers ---------- */
  function h(tag, props) {
    var el = document.createElement(tag);
    if (props) {
      Object.keys(props).forEach(function (k) {
        var v = props[k];
        if(k==='id'||k==='for')v='bib-'+v;
        else if(['aria-controls','aria-labelledby','aria-describedby'].indexOf(k)!==-1&&v)v=String(v).split(/\s+/).map(function(id){return 'bib-'+id;}).join(' ');
        if (v == null || v === false) return;
        if (k === 'class') el.className = v;
        else if (k === 'text') el.textContent = v;
        else if (k.slice(0, 2) === 'on' && typeof v === 'function') el.addEventListener(k.slice(2), v);
        else if (v === true) el.setAttribute(k, '');
        else el.setAttribute(k, String(v));
      });
    }
    for (var i = 2; i < arguments.length; i++) add(el, arguments[i]);
    return el;
  }
  function add(el, c) {
    if (c == null || c === false) return;
    if (Array.isArray(c)) { c.forEach(function (x) { add(el, x); }); return; }
    el.appendChild(c instanceof Node ? c : document.createTextNode(String(c)));
  }
  function clear(el) { while (el.firstChild) el.removeChild(el.firstChild); return el; }
  function $(id) { return document.getElementById(id); }

  /* Trusted static icon markup only */
  var ICONS = {
    search: '<circle cx="11" cy="11" r="6.5"/><path d="m20 20-4-4"/>',
    bag: '<path d="M5 8.5h14l-1.1 10.6a2 2 0 0 1-2 1.9H8.1a2 2 0 0 1-2-1.9L5 8.5Z"/><path d="M9 8.5V7a3 3 0 0 1 6 0v1.5"/>',
    close: '<path d="M6.5 6.5l11 11M17.5 6.5l-11 11"/>',
    plus: '<path d="M12 6v12M6 12h12"/>',
    minus: '<path d="M6 12h12"/>',
    trash: '<path d="M5 7h14M10 7V5h4v2M7 7l.8 12h8.4L17 7"/>',
    filter: '<path d="M4 7h9M17 7h3M4 17h3M11 17h9"/><circle cx="15" cy="7" r="2"/><circle cx="9" cy="17" r="2"/>',
    check: '<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    book: '<path d="M5 4.5h11a2 2 0 0 1 2 2V20H7a2 2 0 0 1-2-2V4.5Z"/><path d="M5 18a2 2 0 0 1 2-2h11"/><path d="M9 8.5h5"/>',
    box: '<path d="M4 8 12 4l8 4v8l-8 4-8-4V8Z"/><path d="M4 8l8 4 8-4M12 12v8"/>',
    gift: '<rect x="4" y="9" width="16" height="4" rx="1"/><path d="M5.5 13v7h13v-7M12 9v11M12 9C10.5 6 7.5 5.5 7.5 7.5 7.5 9 10 9 12 9Zm0 0c1.5-3 4.5-3.5 4.5-1.5C16.5 9 14 9 12 9Z"/>',
    photo: '<rect x="4" y="5.5" width="16" height="13" rx="2"/><circle cx="9" cy="10" r="1.6"/><path d="m5 17 4.5-4 3 2.5 2.5-2 4 3.5"/>',
    arrow: '<path d="M5 12h14M13 6l6 6-6 6"/>',
    chev: '<path d="m9 6 6 6-6 6"/>'
  };
  function icon(name, cls) {
    var s = h('span', { class: 'ico' + (cls ? ' ' + cls : ''), 'aria-hidden': 'true' });
    s.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round">' + (ICONS[name] || ICONS.box) + '</svg>';
    return s;
  }

  /* Only relative local assets or https URLs */
  function safeSrc(s) {
    if (typeof s !== 'string') return null;
    s = s.trim();
    if (window.BABY_PREVIEW_ASSETS && window.BABY_PREVIEW_ASSETS[s]) s = window.BABY_PREVIEW_ASSETS[s];
    if (!s) return null;
    if (/^data:image\/(?:png|jpe?g|webp|svg\+xml);base64,[a-z0-9+/=\s]+$/i.test(s)) return s;
    if (/^https:\/\//i.test(s)) return s;
    if (/^[a-z][a-z0-9+.-]*:/i.test(s) || s.indexOf('//') === 0) return null;
    return s;
  }
  function compName(c) { return c ? L({ ar: c.ar, en: c.en }) : ''; }
  function isStoryComp(c) { return String((c && (c.key || c.sku)) || '').toUpperCase().indexOf('STORY') !== -1; }

  function picture(src, alt, opts) {
    opts = opts || {};
    var im = h('img', { src: src, alt: alt || '', loading: opts.eager ? 'eager' : 'lazy', decoding: 'async' });
    if (opts.w) { im.setAttribute('width', opts.w); im.setAttribute('height', opts.h || opts.w); }
    im.addEventListener('error', function () {
      var ph = h('span', { class: 'ph' }, icon(opts.iconName || 'box'), opts.label ? h('span', { class: 'ph-name', text: opts.label }) : null);
      if (im.parentNode) im.parentNode.replaceChild(ph, im);
    });
    return im;
  }

  /* Main kit artwork follows the selected preview direction; individual
     component photos and product links retain their merchant sources. */
  function productPhoto(p) {
    var kit = safeSrc(p.image);
    if (kit) return { src: kit, kind: 'kit' };
    for (var i = 0; i < p.components.length; i++) {
      var s = safeSrc(p.components[i].image);
      if (s) return { src: s, kind: 'cutout' };
    }
    return null;
  }
  function photoBox(p, cls, eager) {
    var ph = productPhoto(p);
    if (ph && ph.kind === 'kit') return h('span', { class: 'photo photo--kit ' + (cls || '') }, picture(ph.src, L(p.title), { eager: eager }));
    var opt = p.options.filter(function (o) { return o.id === p.defaultOption; })[0] || p.options[0] || null;
    var box = h('span', { class: 'photo photo--source ' + (cls || '') });
    box.appendChild(sourceScene(optionComponents(p, opt), eager));
    return box;
  }
  function sourceScene(comps, eager) {
    var seen = {}, list = comps.filter(function (c) {
      /* Accessory photos show a demonstration stroller; keep those in the
         individually labelled gallery instead of implying extra strollers. */
      if (!safeSrc(c.image) || ['flyer','winter','rain'].indexOf(c.key) !== -1) return false;
      var group = c.mediaGroup || c.image;
      if (seen[group]) return false;
      seen[group] = true; return true;
    });
    /* Keep the actual story visible even in a large learning bundle. */
    if (list.length > 4) {
      var story = list.filter(isStoryComp)[0];
      list = list.slice(0, story ? 3 : 4);
      if (story && list.indexOf(story) === -1) list.push(story);
    }
    var scene = h('span', { class: 'source-scene source-scene--' + Math.min(list.length, 4), role: 'group', 'aria-label': list.map(compName).join(' + ') });
    list.forEach(function (c, i) {
      scene.appendChild(h('span', { class: 'source-piece source-piece--' + i, 'data-component': c.key }, picture(safeSrc(c.image), compName(c), { eager: eager })));
    });
    return scene;
  }
  function optionComponents(p, opt) {
    var keys = opt && opt.componentKeys.length ? opt.componentKeys : p.componentKeys;
    if (!keys.length) return p.components;
    var list = keys.map(function (k) {
      return p.components.filter(function (c) { return c.key === k; })[0] || COMPONENTS[k] || null;
    }).filter(Boolean);
    list = list.length ? list : p.components;
    var overrides = opt && (DATA.optionComponentMedia || {})[opt.id] || {};
    return list.map(function (c) { return Object.assign({}, c, overrides[c.key] || {}); });
  }

  /* ---------- Pricing ---------- */
  function priceInfo(p) {
    var opts = p.options;
    var prices = opts.map(function (o) { return num(o.price); }).filter(function (x) { return x != null; });
    var varies = p.priceVaries || uniq(prices).length > 1;
    var min = num(p.minPrice);
    if (min == null) min = prices.length ? Math.min.apply(null, prices) : num(p.price);
    var price = varies ? min : (prices.length ? prices[0] : (num(p.price) != null ? num(p.price) : min));
    var gift = L(p.giftLine).trim();
    var ref = null, save = null, saveVaries = false;
    if (!gift) {
      if (opts.length > 1) {
        var refs = uniq(opts.map(function (o) { var r = num(o.referencePrice); return r != null ? r : num(p.referencePrice); }));
        if (refs.length === 1 && refs[0] != null && !varies) ref = refs[0];
        var sv = uniq(opts.map(function (o) { var s = num(o.savingsPreview); return s != null ? s : num(p.savingsPreview); }));
        if (sv.length === 1 && sv[0] > 0) save = sv[0];
        else if (sv.some(function (x) { return x > 0; })) saveVaries = true;
      } else {
        var o = opts[0] || {};
        ref = num(o.referencePrice); if (ref == null) ref = num(p.referencePrice);
        save = num(o.savingsPreview); if (save == null) save = num(p.savingsPreview);
      }
      if (ref != null && price != null && ref <= price) ref = null;
      if (!(save > 0)) save = null;
    }
    return { price: price, varies: varies, ref: ref, save: save, saveVaries: saveVaries, gift: gift };
  }
  function selectedInfo(p, opt) {
    if (!opt) return priceInfo(p);
    var gift = L(p.giftLine).trim();
    var price = num(opt.price); if (price == null) price = num(p.price);
    var ref = null, save = null;
    if (!gift) {
      ref = num(opt.referencePrice); if (ref == null && p.options.length <= 1) ref = num(p.referencePrice);
      save = num(opt.savingsPreview); if (save == null && p.options.length <= 1) save = num(p.savingsPreview);
      if (ref != null && price != null && ref <= price) ref = null;
      if (!(save > 0)) save = null;
    }
    return { price: price, varies: false, ref: ref, save: save, saveVaries: false, gift: gift };
  }
  function priceBlock(info, cls) {
    var box = h('div', { class: 'price ' + (cls || '') });
    var row = h('p', { class: 'price-now' });
    if (info.varies) row.appendChild(h('span', { class: 'price-from', text: t('from') }));
    row.appendChild(h('strong', { class: 'price-val', text: money(info.price) }));
    if (!info.gift && info.save != null) row.appendChild(h('span', { class: 'price-save', text: t('save')(money(info.save)) }));
    box.appendChild(row);
    if (info.gift) {
      box.appendChild(h('p', { class: 'price-gift' }, icon('gift'), h('span', { text: info.gift })));
    } else if (info.ref != null) {
      box.appendChild(h('p', { class: 'price-ref' }, h('s', { text: money(info.ref) })));
    } else if (info.saveVaries) {
      box.appendChild(h('p', { class: 'price-ref', text: t('saveVaries') }));
    }
    return box;
  }
  function swatches(p) {
    var hexes = p.options.map(function (o) { return o.colourHex; }).filter(Boolean);
    if (p.options.length < 2) return h('span', { class: 'swatches' });
    var box = h('span', { class: 'swatches' });
    if (hexes.length) {
      var dots = h('span', { class: 'sw-dots', 'aria-hidden': 'true' });
      hexes.slice(0, 5).forEach(function (hx) { var d = h('span', { class: 'sw' }); d.style.backgroundColor = hx; dots.appendChild(d); });
      box.appendChild(dots);
    }
    box.appendChild(h('span', { class: 'sw-n', text: t('optsN')(p.options.length) }));
    return box;
  }

  /* ---------- Filtering ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ْـ]/g, '')
      .replace(/[أإآ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
      .replace(/\s+/g, ' ').trim();
  }
  var hay = {};
  products.forEach(function (p) {
    var parts = [p.title.ar, p.title.en];
    if (p.modelLine) parts.push(p.modelLine.ar, p.modelLine.en);
    p.components.forEach(function (c) { parts.push(c.ar, c.en); });
    p.options.forEach(function (o) { parts.push(o.label.ar, o.label.en); });
    hay[p.id] = norm(parts.join(' '));
  });
  function inBudget(price, b) {
    if (b === 'all') return true;
    if (price == null) return false;
    if (b === 'lt1000') return price < 1000;
    if (b === '1000-2499') return price >= 1000 && price <= 2499;
    if (b === '2500-4999') return price >= 2500 && price <= 4999;
    if (b === '5000plus') return price >= 5000;
    return true;
  }
  function filterList(cat) {
    var tokens = norm(state.q).split(' ').filter(Boolean);
    return products.filter(function (p) {
      if (cat !== 'all' && p.category !== cat) return false;
      if (tokens.length && !tokens.every(function (tk) { return hay[p.id].indexOf(tk) !== -1; })) return false;
      if (!inBudget(priceInfo(p).price, state.budget)) return false;
      if (state.story && !p.customStory) return false;
      return true;
    });
  }
  function results() {
    var list = filterList(state.cat);
    if (state.sort === 'asc' || state.sort === 'desc') {
      var dir = state.sort === 'asc' ? 1 : -1;
      list.sort(function (a, b) { return ((priceInfo(a).price || 0) - (priceInfo(b).price || 0)) * dir || a._i - b._i; });
    } else {
      list.sort(function (a, b) {
        var fa = a.featuredRank != null, fb = b.featuredRank != null;
        if (fa && fb) return a.featuredRank - b.featuredRank;
        if (fa !== fb) return fa ? -1 : 1;
        return CAT_IDS.indexOf(a.category) - CAT_IDS.indexOf(b.category) || a._i - b._i;
      });
    }
    return list;
  }
  function filtersActive() { return !!(state.q.trim() || state.budget !== 'all' || state.story); }

  /* ---------- URL state (hash route: works on file:// and HTTP) ---------- */
  function parseParams(p) {
    var s = {};
    s.lang=DEFAULTS.lang;
    var cat = p.get('cat'); s.cat = CAT_IDS.indexOf(cat) !== -1 ? cat : 'all';
    s.q = (p.get('q') || '').slice(0, 80);
    var b = p.get('budget'); s.budget = BUDGETS.indexOf(b) !== -1 ? b : 'all';
    s.story = p.get('story') === '1';
    var so = p.get('sort'); s.sort = SORTS.indexOf(so) !== -1 ? so : 'suggested';
    s.view='auto';
    s.product=null;

    return s;
  }
  function readUrl() {
    var hash = location.hash || '';
    var p;
    try {
      if (hash.indexOf('#/') === 0) p = new URLSearchParams(hash.slice(2));
      else p = new URLSearchParams(location.search);
    } catch (e) { return Object.assign({}, DEFAULTS); }
    return parseParams(p);
  }
  function serialize(s) {
    var p = new URLSearchParams();
    if (s.lang !== 'ar') p.set('lang', s.lang);
    if (s.cat !== 'all') p.set('cat', s.cat);
    if (s.q.trim()) p.set('q', s.q.trim());
    if (s.budget !== 'all') p.set('budget', s.budget);
    if (s.story) p.set('story', '1');
    if (s.sort !== 'suggested') p.set('sort', s.sort);
    if (s.view !== 'auto') p.set('view', s.view);
    if (s.product && s.product !== '__missing') p.set('product', s.product);
    if (s.product && s.product.indexOf('component-') === 0 && s.componentSku) p.set('sku',s.componentSku);
    return '#/' + p.toString();
  }
  var lastWritten = null;
  function writeUrl(push) {
    var hash = serialize(state);
    if (hash === location.hash || (hash === '#/' && !location.hash && !location.search)) { lastWritten = hash; return; }
    lastWritten = hash;
    try {
      history[push ? 'pushState' : 'replaceState'](null, '', location.pathname + location.search + hash);
    } catch (e) {
      try { if (push) location.hash = hash.slice(1); else location.replace(hash); } catch (e2) { /* keep in memory */ }
    }
  }
  function hrefFor(changes) { return serialize(Object.assign({}, state, changes)); }
  function onUrlChange(){var next=readUrl();Object.assign(state,next);var input=$('q');if(input)input.value=state.q;renderCatalogDynamic();}

  function keepFocus(fn) {
    var a = document.activeElement;
    var id = a && a.id;
    var scrolls = Array.prototype.map.call(document.querySelectorAll('.overlay:not([hidden]) .panel-scroll'), function (s) {
      return { ov: s.closest('.overlay').id, top: s.scrollTop };
    });
    fn();
    scrolls.forEach(function (s) { var el = document.querySelector('#' + s.ov + ' .panel-scroll'); if (el) el.scrollTop = s.top; });
    if (id) {
      var el = $(id);
      if (el && el !== document.activeElement && !el.closest('[hidden]')) {
        try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
      }
    }
  }
  function reduceMotion() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  function scrollToEl(el) { if (el) el.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'start' }); }

  /* ---------- Navigation ---------- */
  function linkTo(changes,attrs,kids){
    if(changes.product&&byId[changes.product]){
      var p=byId[changes.product],props=Object.assign({},attrs||{});
      if(!p.published){props['aria-disabled']='true';props.tabindex='-1';if(!p.launchReady&&String(props.class||'').indexOf('cta')!==-1){props.text=state.lang==='ar'?'قريبًا':'Coming soon';kids=null;}return h('span',props,kids);}
      props.href=liveProductUrl(p);return h('a',props,kids);
    }
    var a=h('a',Object.assign({href:hrefFor(changes)},attrs||{}),kids);
    a.addEventListener('click',function(e){if(e.metaKey||e.ctrlKey||e.shiftKey||e.button!==0)return;e.preventDefault();go(changes,true);});return a;
  }
  function go(changes,push){Object.assign(state,changes);writeUrl(push);renderCatalogDynamic();}
  function jumpTo(id){scrollToEl($(id));}
  function renderSearch(){
    var input=$('q');input.value=state.q;var pending;
    input.addEventListener('input',function(){clearTimeout(pending);pending=setTimeout(function(){go({q:input.value},false);},160);});
    $('searchForm').addEventListener('submit',function(e){e.preventDefault();clearTimeout(pending);go({q:input.value},true);scrollToEl($('catalog'));});
    input.placeholder=t('searchPh');
    $('searchLabel').textContent=t('searchLabel');
  }

  /* ---------- Pink Friday decorations ---------- */
  var festivalObserver = null;
  function yellowHeading(value, word) {
    var at = value.lastIndexOf(word);
    if (at < 0) return value;
    return [value.slice(0, at), h('span', { class: 'yellow-word', text: word }), value.slice(at + word.length)];
  }
  function festivalArt(zone) {
    var layer = h('span', { class: 'festival-art festival-art--' + zone, 'aria-hidden': 'true' });
    var stars = [[2,14,92,-17,.7],[25,5,42,12,.35],[56,9,34,-8,.45],[88,3,76,18,.55],[95,42,72,-12,.6],[10,83,64,9,.4],[72,91,52,-18,.5],[42,76,27,15,.25]];
    var colors = ['#F8BFD6','#DDDBEE','#F6E9D2'];
    stars.forEach(function (star, i) {
      var style = '--star-x:' + star[0] + '%;--star-y:' + star[1] + '%;--star-size:' + star[2] + 'px;--star-turn:' + star[3] + 'deg;--star-depth:' + star[4] + ';--star-color:' + colors[i % colors.length] + ';--star-duration:' + (7 + i % 4) + 's;--star-delay:-' + (i * 1.3) + 's';
      layer.appendChild(h('span', { class: 'festival-piece' + (i % 3 === 1 ? ' festival-piece--spark' : ''), style: style }, h('span', { class: 'festival-shape' })));
    });
    return layer;
  }
  function decorateFestivalSection(section, zone) {
    if (!section) return;
    section.classList.add('festival-surface');
    if (!section.querySelector(':scope > .festival-art')) section.insertBefore(festivalArt(zone), section.firstChild);
    if (reduceMotion()) return;
    if (!festivalObserver && window.IntersectionObserver) {
      festivalObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) { entry.target.classList.toggle('festival-active', entry.isIntersecting); });
      }, { threshold: 0.01 });
    }
    if (festivalObserver && !section.dataset.festivalObserved) { festivalObserver.observe(section); section.dataset.festivalObserved = 'true'; }
    else if (!festivalObserver) section.classList.add('festival-active');
  }
  function renderFestivalDecor() {
    ['intro','needs','faq'].forEach(function (zone) { decorateFestivalSection($(zone), zone); });
  }
  function bindFestivalMotion() {
    var surface = $('site');
    if (!surface || surface.dataset.festivalBound) return;
    surface.dataset.festivalBound = 'true';
    var last = null, pending = null, frame = 0;
    function reset() {
      if (last) { last.style.removeProperty('--festival-x'); last.style.removeProperty('--festival-y'); }
      last = null; pending = null;
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
    }
    surface.addEventListener('pointermove', function (event) {
      if (event.pointerType !== 'mouse' || reduceMotion() || !window.matchMedia('(pointer: fine)').matches) return;
      var section = event.target.closest('.festival-surface');
      if (!section || !surface.contains(section)) { reset(); return; }
      if (last && last !== section) { last.style.removeProperty('--festival-x'); last.style.removeProperty('--festival-y'); }
      last = section; pending = { x: event.clientX, y: event.clientY };
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (!last || !pending) return;
        var rect = last.getBoundingClientRect();
        var x = Math.max(-1, Math.min(1, (pending.x - rect.left) / rect.width * 2 - 1));
        var y = Math.max(-1, Math.min(1, (pending.y - rect.top) / rect.height * 2 - 1));
        last.style.setProperty('--festival-x', (x * 16).toFixed(2) + 'px');
        last.style.setProperty('--festival-y', (y * 12).toFixed(2) + 'px');
      });
    }, { passive: true });
    surface.addEventListener('pointerleave', reset, { passive: true });
  }

  /* ---------- Intro ---------- */
  function renderIntro() {
    var sec = clear($('intro'));
    sec.appendChild(h('div', { class: 'wrap intro-in' },
      h('div', { class: 'intro-copy' },
        h('p', { class: 'intro-kicker', text: 'PINK FRIDAY' }),
        h('h1', { class: 'intro-h', id: 'introTitle', text: t('introTitle') }),
        h('span', { class: 'intro-rule', 'aria-hidden': 'true' }),
        h('p', { class: 'intro-p', text: state.lang === 'ar' ? 'حاجات بتكمّل بعض، في عرض واحد.' : 'Good things together. One better price.' }),
        h('button', { type: 'button', class: 'btn btn-navy', onclick: function () { scrollToEl($('picks')); } }, h('span', { text: state.lang === 'ar' ? 'اكتشفي العروض' : 'Explore the offers' }))),
      h('div', { class: 'intro-badge' }, h('img', { src: safeSrc('assets/pink-friday-badge.png'), alt: t('badgeAlt'), width: '1536', height: '1024' }))));
  }

  /* Featured products use the same open, white product grid as the Home. */
  function bandArt() {
    return festivalArt('picks');
  }
  function bundleCardBadges(info) {
    return h('span', { class: 'bundle-card-badges' },
      h('span', { class: 'bundle-card-ribbon', text: 'Bundles' }),
      info.save > 0 ? h('span', { class: 'bundle-card-saving', text: t('save')(money(info.save)) }) : null);
  }
  function bundleCardValues(p, cls) {
    var values = h('ul', { class: cls });
    p.benefits.slice(0, 2).forEach(function (benefit) {
      var full = L(benefit), label = full.split(/[؛;]/)[0].trim().replace(/\.$/, '');
      values.appendChild(h('li', {},
        h('span', { class: 'bundle-card-check', 'aria-hidden': 'true' }, icon('check')),
        h('span', { class: 'bundle-card-value', title: full, text: label })));
    });
    return values;
  }
  function pickCard(p, lifted) {
    var info = priceInfo(p);
    var href = { product: p.id };
    return h('article', { class: 'pick native-bundle-card' + (lifted ? ' pick--lifted' : ''), 'data-id': p.id },
      linkTo(href, { class: 'pick-media native-card-media', 'aria-label': L(p.title) }, [photoBox(p, 'photo--pick', lifted), bundleCardBadges(info)]),
      h('div', { class: 'pick-body' },
        h('h3', { class: 'pick-name native-card-heading' }, linkTo(href, { class: 'pick-link', id: 'pk-' + p.id, text: L(p.title) })),
        bundleCardValues(p, 'pick-values'),
        priceBlock(info, 'price--pick'),
        linkTo(href, {class:'pick-cta',id:'pick-cta-'+p.id,text:p.customStory?t('ctaStory'):t('ctaSee')})));
  }
  function railArrows(railId, label) {
    function move(dir) {
      var rail = $(railId);
      if (!rail) return;
      var rtl = document.documentElement.dir === 'rtl';
      var step = Math.max(200, rail.clientWidth * 0.8);
      rail.scrollBy({ left: dir * step * (rtl ? -1 : 1), behavior: reduceMotion() ? 'auto' : 'smooth' });
    }
    return h('div', { class: 'arrows', role: 'group', 'aria-label': label },
      h('button', { type: 'button', class: 'arrow arrow--prev', id: railId + '-prev', 'aria-label': t('prev'), 'aria-controls': railId, onclick: function () { move(-1); } }, icon('chev', 'ico-dir ico-flip')),
      h('button', { type: 'button', class: 'arrow arrow--next', id: railId + '-next', 'aria-label': t('next'), 'aria-controls': railId, onclick: function () { move(1); } }, icon('chev', 'ico-dir')));
  }
  function syncArrows(railId) {
    var rail = $(railId), prev = $(railId + '-prev'), next = $(railId + '-next');
    if (!rail || !prev || !next) return;
    var max = rail.scrollWidth - rail.clientWidth;
    var pos = Math.abs(rail.scrollLeft);
    var wrap = prev.parentNode;
    wrap.hidden = max <= 4;
    prev.disabled = pos <= 4;
    next.disabled = pos >= max - 4;
  }
  function bindRail(railId) {
    var rail = $(railId);
    if (!rail) return;
    rail.addEventListener('scroll', function () { syncArrows(railId); }, { passive: true });
    requestAnimationFrame(function () { syncArrows(railId); });
  }
  function renderPicks() {
    var sec = clear($('picks'));
    if (!featured.length) { sec.hidden = true; return; }
    sec.hidden = false;

    var rail = h('div', { class: 'picks-rail', id: 'picksRail', tabindex: '0', 'aria-label': t('picksSub') });
    featured.forEach(function (p, i) { rail.appendChild(pickCard(p, i === 0)); });
    sec.appendChild(h('div', { class: 'wrap picks-in' },
      h('div', { class: 'picks-head', 'data-reveal': '' },
        h('div', {},
          h('h2', { class: 'picks-h', id: 'picksTitle', text: t('picksTitle') }),
          h('p', { class: 'picks-sub', text: t('picksSub') })),
        railArrows('picksRail', t('picksSub'))),
      rail));
    bindRail('picksRail');
  }

  /* ---------- Need circles ---------- */
  function catImage(c) {
    var s = safeSrc(c.image);
    if (s) return { src: s, kind: 'scene' };
    var list = products.filter(function (p) { return p.category === c.id; })
      .sort(function (a, b) { return (a.featuredRank || 99) - (b.featuredRank || 99) || a._i - b._i; });
    for (var i = 0; i < list.length; i++) {
      var ph = productPhoto(list[i]);
      if (ph) return ph;
    }
    return null;
  }
  function renderNeeds() {
    var sec = clear($('needs'));
    var rail = h('ul', { class: 'needs-rail', id: 'needsRail' });
    categories.forEach(function (c, i) {
      var im = catImage(c);
      var sourceComps = c.sourceKeys.map(function (key) { return COMPONENTS[key]; }).filter(Boolean);
      var btn = h('button', {
        type: 'button', class: 'need', id: 'cat-' + c.id, 'aria-pressed': state.cat === c.id ? 'true' : 'false',
        onclick: function () { selectCat(state.cat === c.id ? 'all' : c.id); }
      },
        h('span', { class: 'need-circle' + (sourceComps.length ? ' need-circle--source' : im ? ' need-circle--' + im.kind : '') }, sourceComps.length ? sourceScene(sourceComps, false) : im ? picture(im.src, '', { label: '' }) : icon('box')),
        h('span', { class: 'need-name', text: L(c.label) }));
      rail.appendChild(h('li', { class: 'need-item', 'data-reveal': '', style: '--i:' + i }, btn));
    });
    sec.appendChild(h('div', { class: 'wrap' },
      h('div', { class: 'needs-head' },
        h('h2', { class: 'needs-h', id: 'needsTitle', text: t('needsTitle') }),
        h('div', { class: 'needs-tools' },
          h('button', { type: 'button', class: 'textbtn', id: 'cat-all', 'aria-pressed': state.cat === 'all' ? 'true' : 'false', onclick: function () { selectCat('all'); } }, t('viewAll')),
          railArrows('needsRail', t('needsTitle')))),
      rail));
    bindRail('needsRail');
  }
  function syncNeeds() {
    ['all'].concat(CAT_IDS).forEach(function (id) {
      var b = $('cat-' + id);
      if (b) b.setAttribute('aria-pressed', state.cat === id ? 'true' : 'false');
    });
  }
  function selectCat(id) {
    if (state.cat === id) return;
    go({ cat: id }, true);
    scrollToEl($('catalog'));
  }

  /* ---------- Catalogue ---------- */
  function renderCatalogHead(list) {
    var el = clear($('catalogHead'));
    var title = state.cat === 'all' ? t('allTitle') : L(catById[state.cat].label);
    var tot = state.cat === 'all' ? products.length : catById[state.cat].count;
    el.appendChild(h('h2', { class: 'catalog-h', id: 'catalogTitle', text: title }));
    el.appendChild(h('p', { class: 'catalog-count', text: t('results')(list.length, tot) }));
    $('liveCount').textContent = t('results')(list.length, tot);
  }
  function budgetSelect(id) {
    var sel = h('select', { id: id, class: 'sel' });
    BUDGETS.forEach(function (b) {
      var o = h('option', { value: b, text: b === 'all' ? t('bAll') : t('b' + b) });
      if (state.budget === b) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { go({ budget: sel.value }, true); });
    return sel;
  }
  function sortSelect(id) {
    var sel = h('select', { id: id, class: 'sel' });
    SORTS.forEach(function (s) {
      var o = h('option', { value: s, text: t('s' + s) });
      if (state.sort === s) o.selected = true;
      sel.appendChild(o);
    });
    sel.addEventListener('change', function () { go({ sort: sel.value }, true); });
    return sel;
  }
  function storyToggle(id) {
    var cb = h('input', { type: 'checkbox', id: id, class: 'tg-input' });
    cb.checked = state.story;
    cb.addEventListener('change', function () { go({ story: cb.checked }, true); });
    return h('label', { class: 'tg', for: id }, cb, h('span', { class: 'tg-box', 'aria-hidden': 'true' }, icon('check')), h('span', { text: t('story') }));
  }
  function activeFilterCount() { return (state.budget !== 'all' ? 1 : 0) + (state.story ? 1 : 0); }
  function renderFilterBar() {
    var bar = clear($('filterBar'));
    var n = activeFilterCount();
    bar.appendChild(h('div', { class: 'fb-desk' },
      h('label', { class: 'fld' }, h('span', { class: 'fld-l', text: t('budget') }), budgetSelect('f-budget')),
      storyToggle('f-story'),
      h('span', { class: 'fb-spacer' }),
      h('label', { class: 'fld' }, h('span', { class: 'fld-l', text: t('sort') }), sortSelect('f-sort'))));
    bar.appendChild(h('div', { class: 'fb-mob' },
      h('button', { type: 'button', class: 'btn btn-line fb-open', id: 'f-open', 'aria-haspopup': 'dialog', onclick: function (e) { openFilters(e.currentTarget); } },
        icon('filter'), h('span', { text: t('filters') }), n ? h('span', { class: 'fb-badge', text: String(n) }) : null),
      h('label', { class: 'fld fld--compact' }, h('span', { class: 'sr-only', text: t('sort') }), sortSelect('f-sort-m'))));
  }
  function renderChips() {
    var el = clear($('chips'));
    var chips = [];
    if (state.q.trim()) chips.push({ label: t('chipQ')(state.q.trim()), off: { q: '' } });
    if (state.budget !== 'all') chips.push({ label: t('b' + state.budget), off: { budget: 'all' } });
    if (state.story) chips.push({ label: t('story'), off: { story: false } });
    if (!chips.length) { el.hidden = true; return; }
    el.hidden = false;
    chips.forEach(function (c, i) {
      el.appendChild(h('button', {
        type: 'button', class: 'chip', id: 'chip-' + i, 'aria-label': t('removeChip')(c.label),
        onclick: function () {
          if ('q' in c.off) { var inp = $('q'); if (inp) inp.value = ''; }
          go(c.off, true);
          var f = $('chip-0') || $(isDesk() ? 'f-budget' : 'f-open'); if (f) f.focus();
        }
      }, h('span', { text: c.label }), icon('close')));
    });
    el.appendChild(h('button', { type: 'button', class: 'chip-clear', id: 'chip-clear', text: t('clearAll'), onclick: resetFilters }));
  }
  function isDesk() { return ui.size === 'md' || ui.size === 'lg'; }
  function resetFilters() {
    var i = $('q'); if (i) i.value = '';
    go({ q: '', budget: 'all', story: false }, true);
    var f = $(isDesk() ? 'f-budget' : 'f-open'); if (f) f.focus();
  }

  var TILE_FIELDS = ['f-blush', 'f-navy', 'f-ivory'];
  function cardEl(p, idx, reveal) {
    var info = priceInfo(p);
    var href = { product: p.id };
    return h('article', { class: 'card native-bundle-card', 'data-id': p.id, 'data-reveal': reveal ? '' : null, style: reveal ? '--i:' + (idx % 6) : null },
      linkTo(href, { class: 'card-media native-card-media', 'aria-label': L(p.title) }, [photoBox(p, 'photo--card'), bundleCardBadges(info)]),
      h('div', { class: 'card-body' },
        h('h3', { class: 'card-name native-card-heading' }, linkTo(href, { class: 'card-link', id: 'cl-' + p.id, text: L(p.title) })),
        bundleCardValues(p, 'card-values'),
        priceBlock(info, 'price--card'),
        linkTo(href, { class: 'card-cta', id: 'cta-' + p.id, }, p.customStory ? t('ctaStory') : t('ctaSee'))));
  }
  function renderGrid(list) {
    var grid = clear($('grid'));
    grid.setAttribute('data-cols', String(ui.cols));
    if (!list.length) {
      grid.appendChild(h('div', { class: 'empty' },
        h('p', { class: 'empty-t', text: t('emptyT') }),
        h('p', { class: 'empty-p', text: t('emptyP') }),
        h('button', { type: 'button', class: 'btn btn-navy', id: 'empty-reset', text: t('reset'), onclick: resetFilters })));
      return;
    }
    var reveal = !ui.revealed;
    list.forEach(function (p, i) { grid.appendChild(cardEl(p, i, reveal)); });
    if (ui.cols > 1 && list.length < ui.cols && (state.cat !== 'all' || filtersActive())) {
      var leaveCat = state.cat !== 'all';
      grid.appendChild(h('div', { class: 'filler' },
        h('p', { class: 'filler-t', text: t('fillerT') }),
        h('button', { type: 'button', class: 'btn btn-line', id: 'filler-btn', text: leaveCat ? t('fillerAll')(products.length) : t('fillerClear'),
          onclick: function () { if (leaveCat) go({ cat: 'all' }, true); else resetFilters(); } })));
    }
    observeReveal(grid);
  }
  function renderCatalogDynamic() {
    keepFocus(function () {
      var list = results();
      syncNeeds();
      renderCatalogHead(list);
      renderFilterBar();
      renderChips();
      renderGrid(list);
      if (!$('filterDialog').hidden) renderFilterPanel();
    });
  }

  /* ---------- FAQ + footer ---------- */
  function renderFaq() {
    var sec = clear($('faq'));
    var list = h('div', { class: 'faq-list' });
    t('faq').forEach(function (qa, i) {
      list.appendChild(h('details', { class: 'faq-item', open: i === 0 },
        h('summary', {}, h('span', { text: qa[0] }), icon('plus', 'faq-ico')),
        h('p', { text: qa[1] })));
    });
    sec.appendChild(h('div', { class: 'wrap faq-in' },
      h('h2', { class: 'faq-h', id: 'faqTitle', text: t('faqTitle') }), list));
  }
  /* ---------- Dialogs (bag, mobile filters) ---------- */
  var stack = [], previousNativeOverflow='';
  function focusables(root) {
    return Array.prototype.filter.call(
      root.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])'),
      function (el) { return el.offsetParent !== null; });
  }
  function openDialog(id, opener) {
    var ov = $(id);
    if (ov.hidden) stack.push({ id: id, opener: opener || document.activeElement });
    previousNativeOverflow=nativeDocument.documentElement.style.overflow;nativeDocument.documentElement.style.overflow='hidden';
    ov.hidden = false;
    $('site').setAttribute('inert', '');
    $('site').classList.add('is-locked');
    var panel = ov.querySelector('.panel');
    requestAnimationFrame(function () {
      ov.classList.add('is-open');
      (panel.querySelector('.panel-close') || panel).focus();
    });
  }
  function closeTop() {
    var top = stack.pop();
    if (!top) return;
    var ov = $(top.id);
    ov.classList.remove('is-open');
    ov.hidden = true;
    if (!stack.length) { $('site').removeAttribute('inert'); $('site').classList.remove('is-locked');nativeDocument.documentElement.style.overflow=previousNativeOverflow; }
    var back = top.opener;
    if (back && back.id && !document.body.contains(back)) back = $(back.id);
    if (back && document.body.contains(back)) { try { back.focus({ preventScroll: true }); } catch (e) { back.focus(); } }
  }
  document.addEventListener('keydown', function (e) {
    if (!stack.length) return;
    var top = $(stack[stack.length - 1].id);
    if (e.key === 'Escape') { e.preventDefault(); closeTop(); return; }
    if (e.key === 'Tab') {
      var panel = top.querySelector('.panel');
      var f = focusables(panel);
      if (!f.length) { e.preventDefault(); panel.focus(); return; }
      var first = f[0], last = f[f.length - 1];
      if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  Array.prototype.forEach.call(document.querySelectorAll('.overlay [data-close]'), function (b) { b.addEventListener('click', closeTop); });
  function closeBtn() { return h('button', { type: 'button', class: 'icon-btn panel-close', 'aria-label': t('close'), onclick: closeTop }, icon('close')); }

  function openFilters(opener) { renderFilterPanel(); openDialog('filterDialog', opener); }
  function renderFilterPanel() {
    var panel = $('filterDialog').querySelector('.panel');
    keepFocus(function () {
      clear(panel);
      var n = filterList(state.cat).length;
      panel.appendChild(h('div', { class: 'panel-head' }, h('h2', { class: 'panel-title', id: 'fdTitle', text: t('filters') }), closeBtn()));
      var fs = h('fieldset', { class: 'fd-group' }, h('legend', { class: 'opts-l', text: t('budget') }));
      BUDGETS.forEach(function (b) {
        var id = 'fd-b-' + b;
        var r = h('input', { type: 'radio', name: 'fd-budget', id: id, value: b, class: 'opt-input' });
        if (state.budget === b) r.checked = true;
        r.addEventListener('change', function () { go({ budget: b }, true); });
        fs.appendChild(h('label', { class: 'opt opt--row', for: id }, r, h('span', { class: 'opt-dot', 'aria-hidden': 'true' }), h('span', { class: 'opt-l', text: b === 'all' ? t('bAll') : t('b' + b) })));
      });
      panel.appendChild(h('div', { class: 'panel-scroll' }, fs, h('div', { class: 'fd-group' }, storyToggle('fd-story'))));
      panel.appendChild(h('div', { class: 'panel-foot panel-foot--split' },
        h('button', { type: 'button', class: 'btn btn-line btn-lg', id: 'fd-clear', text: t('clearAll'), disabled: !activeFilterCount(),
          onclick: function () { go({ budget: 'all', story: false }, true); var c = $('fd-b-all'); if (c) c.focus(); } }),
        h('button', { type: 'button', class: 'btn btn-navy btn-lg', id: 'fd-apply', text: t('showN')(n), onclick: function () { closeTop(); scrollToEl($('catalog')); } })));
    });
  }

  /* ---------- Entrance motion (content stays visible without JS / with reduced motion) ---------- */
  var io = null;
  function observeReveal(root) {
    if (reduceMotion() || !window.IntersectionObserver) return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { root: $('site'), rootMargin: '0px 0px -6% 0px', threshold: 0.08 });
    }
    Array.prototype.forEach.call((root || document).querySelectorAll('[data-reveal]:not(.is-in)'), function (el) { io.observe(el); });
    /* Failsafe: tools that capture without scrolling the inner page never leave content hidden */
    if (!ui.revealFailsafe) {
      ui.revealFailsafe = setTimeout(function () {
        if ($('site').scrollTop > 0) return;
        Array.prototype.forEach.call(document.querySelectorAll('[data-reveal]:not(.is-in)'), function (el) { el.classList.add('is-in'); });
      }, 3500);
    }
  }

  /* Native theme owns viewport, header, footer, locale and cart. */
  function renderAll(){bundleRoot.lang=state.lang;bundleRoot.dir=state.lang==='ar'?'rtl':'ltr';renderIntro();renderPicks();renderNeeds();renderFaq();renderCatalogDynamic();renderFestivalDecor();}
  function measure(){var w=bundleRoot.clientWidth||window.innerWidth;var size=w<360?'xs':w<700?'sm':w<1060?'md':'lg';var cols=w<900?2:3;var changed=size!==ui.size||cols!==ui.cols;ui.size=size;ui.cols=cols;$('frame').setAttribute('data-size',size);if(changed&&products.length)renderGrid(results());if(isDesk()&&!$('filterDialog').hidden)closeTop();syncArrows('picksRail');syncArrows('needsRail');}
  async function refreshLiveCatalog(){
    var queue=products.slice(),index=0;
    async function worker(){while(index<queue.length){var p=queue[index++];var timer;
      try{var base=liveConfig.rootUrl||'/';if(base.slice(-1)!=='/')base+='/';var controller=new AbortController();timer=setTimeout(function(){controller.abort();},8000);
        var response=await fetch(base+'products/'+encodeURIComponent(p.handle)+'.js',{headers:{Accept:'application/json'},signal:controller.signal});if(!response.ok)continue;
        var current=await response.json();if(String(current.id)!==p.id)continue;
        var verified=0;p.options.forEach(function(o){var v=current.variants.find(function(v){return String(v.id)===o.variantId;});if(!v)return;verified++;o.price=v.price/100;o.referencePrice=L(p.giftLine).trim()?null:(v.compare_at_price?v.compare_at_price/100:null);o.savingsPreview=o.referencePrice>o.price?o.referencePrice-o.price:null;});
        p.published=p.launchReady&&verified===p.options.length;p.available=!!current.available;
        var prices=p.options.map(function(o){return num(o.price);}).filter(function(v){return v!=null;});if(prices.length)p.minPrice=Math.min.apply(null,prices);
      }catch(e){/* Unverified and unpublished products never get a purchase link. */}finally{clearTimeout(timer);}
    }}
    await Promise.all(Array.from({length:6},worker));renderPicks();renderCatalogDynamic();
  }
  function init(){Object.assign(state,readUrl());measure();renderAll();renderSearch();bindFestivalMotion();if(window.ResizeObserver)new ResizeObserver(measure).observe(bundleRoot);else window.addEventListener('resize',measure);window.addEventListener('popstate',onUrlChange);window.addEventListener('hashchange',onUrlChange);refreshLiveCatalog();}
  init();
})();
